<template>

  <b-modal
      id="reglements-modal"
      modal-class='form reglements-modal'
      modal-footer="hide"
      scrollable
      centered
      :title="'Règlements'"
  >

    <b-row>
      <b-col sm="12" v-if="reglementAgentsLink">
        <a :href="reglementAgentsLink" target="_blank" class="bt btn-red" style="margin-bottom: 20px; padding-left: 20px; background-color: #EFEFEF; color: #6E6E6E">
                <span>
                    <font-awesome-icon :icon="['fas', 'clipboard-list-check']" />
                </span>
          Règlement agents
        </a>
      </b-col>
      <b-col sm="12" v-if="reglementInspecteursLink">
        <a :href="reglementInspecteursLink" target="_blank" class="bt btn-red" style="margin-bottom: 20px; padding-left: 20px; background-color: #FCF2D3; color: #FDC302">
                <span>
                    <font-awesome-icon :icon="['fas', 'clipboard-list-check']" />
                </span>
          Règlement inspecteurs
        </a>
      </b-col>
      <b-col sm="12" v-if="reglementRCRLink">
        <a :href="reglementRCRLink" target="_blank" class="bt btn-red" style="margin-bottom: 20px; padding-left: 20px; background-color: #E3F3FE; color: #0284FD">
                <span>
                    <font-awesome-icon :icon="['fas', 'clipboard-list-check']" />
                </span>
          Règlement RCR
        </a>
      </b-col>
    </b-row>

    <template v-slot:modal-footer hidden>
      <b-button hidden
                class="btn-cancel"
      >
      </b-button>


      <b-button hidden
                class="btn-challenges"
      >
      </b-button>


    </template>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import ApiService from '../../../services/ApiService'

export default {
  name: "ReglementsModal",
  components: {
  },
  data() {
    return {
      isLoading:true,
      reglementRCRLink: '',
      reglementInspecteursLink: '',
      reglementAgentsLink: ''
    }
  },

  computed: {
    ...mapGetters([
      'getGeneral',
      'getChallengeUpdated',
      'getChallengeSelected'
    ])
  },
  created (){
    this.getData();
  },
  methods:{
    async getData() {
      let promises = [];
      if(this.getChallengeSelected){
        promises.push(ApiService.getConcoursApi().getReglement(this.getChallengeSelected,'CONFIG_AGENT').then((data) => {
              let theLawId = data.data;
              this.reglementAgentsLink = ApiService.getMediaApi().get(theLawId);
            },
            () => {
              this.reglementAgentsLink = null;
            }));
        promises.push(ApiService.getConcoursApi().getReglement(this.getChallengeSelected,'CONFIG_INSPECTEUR').then((data) => {
              let theLawId = data.data;
              this.reglementInspecteursLink = ApiService.getMediaApi().get(theLawId);
            },
            () => {
              this.reglementInspecteursLink = null;
            }));
        promises.push(ApiService.getConcoursApi().getReglement(this.getChallengeSelected,'CONFIG_RCR').then((data) => {
              let theLawId = data.data;
              this.reglementRCRLink = ApiService.getMediaApi().get(theLawId);
            },
            () => {
              this.reglementRCRLink = null;
            }));
      }
      await Promise.all(promises);
    }
  },

  watch: {
    getChallengeSelected(){
      this.getData();
    },
  },
}
</script>

